import NotificationBell from "../NotificationBell";
import SidebarToggle from "../Sidebar/SidebarToggle";

const AdminHeader = () => {
  return (
    <header className="flex w-full items-center justify-between pt-4 pb-2 gap-3">
      <SidebarToggle />
      <NotificationBell />
    </header>
  );
};

export default AdminHeader;
